/**
 * 理疗执行模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增理疗执行记录
export const physioExecuteAdd = (params) => {
  return req.post('/system/execution', params);
}

// 获取理疗执行详情
export const physioExecuteInfo = (orderOrderPaymentRecipePhysioExecution ) => {
  return req.get(`/system/execution/${orderOrderPaymentRecipePhysioExecution }`);
}

// 获取理疗详细项目
export const physioExecuteDetails = (recipePhysioId) => {
  return req.get(`/system/execution/item/${recipePhysioId }`);
}

// 获取理疗划价单执行列表
export const physioExecuteList = (params) => {
  return req.get('/system/execution/list', params);
}

// 获取理疗技师列表
export const executionList = (params) => {
  return req.get('/system/execution/person/list', params);
}

// 删除理疗技师
export const executionDelete = (ids) => {
  return req.delete(`/system/execution/person/${ids}`);
}

// 新建理疗技师
export const executionAdd = (params) => {
  return req.post('/system/execution/person', params);
}

// 分页查询账户理疗信息
export const accountPropertyPage = (params) => {
  return req.post('/physio/accountPropertyPage', params);
}

// 患者Id查询患者理疗资产信息
export const accountPhysioProperty = (params) => {
  return req.post('/physio/page/property', params);
}

// 执行理疗项目
export const usePhysio = (params) => {
  return req.post('/physio/usePhysio', params);
}
// 理疗详情查看
export const physioDetail = (params) => {
  return req.get('/physio/physioDetail', params);
}

// 获取核销理疗项目编码
export const getUsePhysioCode = (params) => {
  return req.post('/physio/getUsePhysioCode', params);
}

// 患者Id查询理疗执行记录
export const physioRecord = (params) => {
  return req.get('/physio/physioRecord', params);
}

// 获取执行看板数据
export const executePhysioPage = (params) => {
  return req.post('/physio/executePhysioPage', params);
}

// 撤销执行理疗项目
export const revokePhysio = (params) => {
  return req.post('/physio/revoke', params);
}
// 查询处方内理疗执行记录
export const recordRecipe = (params) => {
  return req.get('/physio/execute/record/recipe/list', params);
}

